import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {LegalVM} from "../../../model/viewModel/legal.vm";
import {retry, switchMap} from "rxjs";
import {LegalService} from "../../../service/legal.service";
import {TranslationService} from "../../../service/translation.service";
import {TitleWrapperService} from "../../../service/title-wrapper.service";

export const TYPE_TERMS_OF_CONDITIONS = "toc"
export const TYPE_PRIVACY_POLICY = "pp"

@Component({
  selector: 'app-legal',
  templateUrl: './legal.component.html',
  styleUrls: ['./legal.component.scss']
})
export class LegalComponent implements OnInit {

  data: LegalVM | undefined;

  constructor(
    private activatedRoute: ActivatedRoute,
    private legalService: LegalService,
    private translationService: TranslationService,
    private titleService: TitleWrapperService,
  ) {
  }

  ngOnInit(): void {
    this.activatedRoute.data
      .pipe(
        switchMap(data => {
          let type = data["type"];
          this.updateTitle(type);
          if (type == TYPE_TERMS_OF_CONDITIONS) {
            return this.legalService.getTermsOfConditions()
          } else {
            return this.legalService.getPrivacyPolicy()
          }
        }),
        retry({
          delay: 1000
        })
      )
      .subscribe({
        next: (legal: LegalVM) => {
          this.data = legal;
        }
      });
  }

  private updateTitle(type: string) {
    this.titleService.setPageName(
      (
        type == TYPE_TERMS_OF_CONDITIONS
          ? this.translationService.trans("terms_and_conditions.page_title", "Terms and conditions")
          : this.translationService.trans("privacy_policy.page_title", "Privacy policy")
      )
    )
  }

}
